import React from 'react';

export const HALF_WIDTH = { upper: 25, lower: 19 };

export const NAME = { upper: 'Markaziy kesuvchi', lower: 'Markaziy kesuvchi' };

/*
 * Upper central incisor: the widest anterior crown. Nearly straight mesial
 * outline with an almost sharp mesio-incisal angle, a more convex distal
 * outline whose contact area sits higher, a straight incisal edge and a stout
 * conical root with a slightly distally inclined blunt apex.
 */
const UPPER_OUTLINE = `M 32 50
    C 28.6 61.5 26 72 25.4 82
    C 25.1 87.5 25.6 92 27 94.2
    Q 28.1 96 31 96
    L 65.2 96
    Q 69.4 96 71.4 93
    C 73.4 88.6 74.9 79 74.6 71.4
    C 74.3 63 71 54.4 68 50
    C 67 43.4 66 33 63.4 22.4
    C 61.8 15.4 59.4 9.4 56.6 7.4
    C 54.6 6 51.2 6.2 49 8
    C 46 10.4 43.2 21.4 40.4 32
    C 38 41 34.8 46.4 32 50 Z`;

const UPPER_CERVICAL = 'M 32 50 C 38.5 44.2 61.5 44.2 68 50';

const UPPER_DETAILS = [
    /* Labial developmental grooves of the incisal third. */
    'M 41 70 C 40.3 78 40.2 87 40.9 93.6',
    'M 59.4 68.5 C 60.2 77 60.4 86.5 59.7 93.8',
];

/*
 * Lower central incisor: the smallest and most symmetrical tooth, with a
 * chisel-shaped crown, a wide straight incisal edge and a slender root that is
 * flattened mesio-distally (hence the longitudinal groove).
 */
const LOWER_OUTLINE = `M 39 44
    C 36.4 34.4 33.6 25 32.4 17.4
    C 31.7 12.2 32.7 7.8 34.9 6
    Q 36.3 4.8 38.9 4.6
    L 61.1 4.6
    Q 63.7 4.8 65.1 6.2
    C 67.3 8 68.3 12.6 67.6 17.8
    C 66.4 25.2 63.6 34.6 61 44
    C 62.6 53.4 63 64.4 61.6 74.4
    C 60.6 82.6 58.6 89.4 55.8 92.2
    Q 52.2 95.6 48.2 93.8
    C 45.4 92.6 43.2 88 41.8 82
    C 40 74.4 38.8 63 38.2 53.6
    C 38.2 49.4 38.4 46.4 39 44 Z`;

const LOWER_CERVICAL = 'M 39 44 C 44.4 48.2 55.6 48.2 61 44';

const LOWER_DETAILS = [
    'M 43.5 10 C 43 18 43.2 26 44 33',
    'M 56.5 10 C 57 18 56.8 26 56 33',
    /* Longitudinal root groove. */
    'M 50.2 52 C 50.6 62 50.8 74 50.4 86',
];

export default function CentralIncisor({ jaw }) {
    const isUpper = jaw === 'upper';

    return (
        <>
            <path d={isUpper ? UPPER_OUTLINE : LOWER_OUTLINE} className="dental-tooth__body" />
            <path d={isUpper ? UPPER_CERVICAL : LOWER_CERVICAL} className="dental-tooth__line" />
            {(isUpper ? UPPER_DETAILS : LOWER_DETAILS).map((d) => (
                <path key={d} d={d} className="dental-tooth__detail" />
            ))}
        </>
    );
}
